import { render, staticRenderFns } from "./soldout.vue?vue&type=template&id=4bf65fb2&scoped=true"
import script from "./soldout.vue?vue&type=script&lang=js"
export * from "./soldout.vue?vue&type=script&lang=js"
import style0 from "./soldout.vue?vue&type=style&index=0&id=4bf65fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf65fb2",
  null
  
)

export default component.exports